/**
 * Provides the dialog injection map consumed by {@link useDialog}.
 * Vendored from `layers/ui` so the dialog system works without the submodule.
 */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.provide(dialogInjectionKey, reactive(new Map()))
})
